import { Component } from '@angular/core';
import { AplicationErrorService } from 'src/app/core/application-error/aplication-error.service';

@Component({
  selector: 'app-application-error',
  templateUrl: './application-error.component.html',
  styleUrls: ['./application-error.component.scss']
})
export class ApplicationErrorComponent {

  errMsg: string = "";
  defaultError: string = "Errore tecnico nell'aplicazione";

  constructor(
    private errService: AplicationErrorService,
  ) {
    // set error msg
    this.errMsg = this.errService.getErrorMsg();

    // if it is an empty string show the default one
    this.errMsg.trim()
  }

  reload() {
    window.location.href = '/home'; 
  }

}
